import { render, staticRenderFns } from "./UploadImageForm.vue?vue&type=template&id=4454c891&"
import script from "./UploadImageForm.vue?vue&type=script&lang=js&"
export * from "./UploadImageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports